var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0778 16.6823L12.6263 12.302C13.792 11.0355 14.5083 9.36053 14.5083 7.51743C14.5077 3.57468 11.2602 0.378906 7.25385 0.378906C3.24752 0.378906 0 3.57468 0 7.51743C0 11.4602 3.24752 14.6559 7.25385 14.6559C8.98486 14.6559 10.5725 14.0572 11.8196 13.0618L16.2883 17.4594C16.506 17.6739 16.8595 17.6739 17.0773 17.4594C17.2955 17.2449 17.2955 16.8968 17.0778 16.6823ZM7.25385 13.5576C3.86406 13.5576 1.11611 10.8534 1.11611 7.51743C1.11611 4.1815 3.86406 1.47721 7.25385 1.47721C10.6437 1.47721 13.3916 4.1815 13.3916 7.51743C13.3916 10.8534 10.6437 13.5576 7.25385 13.5576Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLogo);
export default __webpack_public_path__ + "static/media/search-logo.7431777a5dff7473956a2c70ba70b992.svg";
export { ForwardRef as ReactComponent };